import ChangePassword from './components';

export default ChangePassword;
